import { useAppSelector } from '@store';
import { ButtonPrimary, ButtonSize } from '@ui/src';
import RealMonthlyVolume from './real-monthly-volume';
import { CustomerStatus } from '../../../hoc/customers/types';
import { RealMonthlyVolumesTypes } from './types';

import cn from './aml.module.css';

const RealMonthlyVolumes = ({
  children,
  title,
  monthlyMaxValueIncomingPaymentRangeId,
  monthlyMaxValueOutgoingPaymentRangeId,
  monthlyNumberIncomingTransactionsRangeId,
  monthlyNumberOutgoingTransactionsRangeId,
  monthlyTurnoverRangeId,
  monthlyValueIncomingTransactionsRangeId,
  monthlyValueOutgoingTransactionsRangeId,
  corporate,
  onChange,
  status,
  saveButtonDisabled,
  requestInProgress,
  onSaveChanges,
}: RealMonthlyVolumesTypes): React.JSX.Element => {
  const {
    monthlyTurnover,
    numberOfIncomingTransactions,
    numberOfOutgoingTransactions,
    valueOfIncomingTransactions,
    valueOfOutgoingTransactions,
    maxValueOfIncomingPayment,
    maxValueOfOutgoingPayment,
    monthlyTurnoverCorporate,
    numberOfIncomingTransactionsCorporate,
    numberOfOutgoingTransactionsCorporate,
    valueOfIncomingTransactionsCorporate,
    valueOfOutgoingTransactionsCorporate,
    maxValueOfIncomingPaymentCorporate,
    maxValueOfOutgoingPaymentCorporate,
  } = useAppSelector((state) => state.customersDictionaries);

  return (
    <div
      className={`${cn.realMonthlyVolumeWrapper} ${
        corporate ? cn.realMonthlyVolumeWrapperCorporate : ''
      }`}
    >
      <div
        className={`${cn.expandableRowTop} ${cn.withoutBackground} ${cn.expandableRowTopWithButton}`}
      >
        <div
          className={`${cn.expandableRowTitle} ${
            corporate ? cn.corporateTitle : ''
          } ${cn.expandableRowTitleWithButton}`}
        >
          <div className={cn.expandableRowTitleValue}>{title}</div>
          <ButtonPrimary
            text={requestInProgress ? 'Loading...' : 'Save changes'}
            size={ButtonSize.SMALL}
            disabled={saveButtonDisabled}
            onClick={onSaveChanges}
          />
        </div>
      </div>
      <div className={cn.realMonthlyVolumeWrapper}>
        <RealMonthlyVolume
          title="N. of incoming transactions"
          value={monthlyNumberIncomingTransactionsRangeId}
          list={
            corporate
              ? numberOfIncomingTransactionsCorporate
              : numberOfIncomingTransactions
          }
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: {
                name: 'monthlyNumberIncomingTransactionsRangeId',
                value: data,
              },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        <RealMonthlyVolume
          title="N. of outgoing transactions"
          value={monthlyNumberOutgoingTransactionsRangeId}
          list={
            corporate
              ? numberOfOutgoingTransactionsCorporate
              : numberOfOutgoingTransactions
          }
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: {
                name: 'monthlyNumberOutgoingTransactionsRangeId',
                value: data,
              },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        <RealMonthlyVolume
          title="Value of incoming transactions"
          value={monthlyValueIncomingTransactionsRangeId}
          list={
            corporate
              ? valueOfIncomingTransactionsCorporate
              : valueOfIncomingTransactions
          }
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: {
                name: 'monthlyValueIncomingTransactionsRangeId',
                value: data,
              },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        <RealMonthlyVolume
          title="Value of outgoing transactions"
          value={monthlyValueOutgoingTransactionsRangeId}
          list={
            corporate
              ? valueOfOutgoingTransactionsCorporate
              : valueOfOutgoingTransactions
          }
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: {
                name: 'monthlyValueOutgoingTransactionsRangeId',
                value: data,
              },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        <RealMonthlyVolume
          title="Max. value of incoming payment"
          value={monthlyMaxValueIncomingPaymentRangeId}
          list={
            corporate
              ? maxValueOfIncomingPaymentCorporate
              : maxValueOfIncomingPayment
          }
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: {
                name: 'monthlyMaxValueIncomingPaymentRangeId',
                value: data,
              },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        <RealMonthlyVolume
          title="Max. value of outgoing payment"
          value={monthlyMaxValueOutgoingPaymentRangeId}
          list={
            corporate
              ? maxValueOfOutgoingPaymentCorporate
              : maxValueOfOutgoingPayment
          }
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: {
                name: 'monthlyMaxValueOutgoingPaymentRangeId',
                value: data,
              },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        <RealMonthlyVolume
          title="Monthly turnover"
          value={monthlyTurnoverRangeId}
          list={corporate ? monthlyTurnoverCorporate : monthlyTurnover}
          corporate={corporate}
          onUpdateRange={(data) =>
            onChange({
              target: { name: 'monthlyTurnoverRangeId', value: data },
            })
          }
          disabled={status === CustomerStatus.CLOSED}
        />
        {children}
      </div>
    </div>
  );
};

export default RealMonthlyVolumes;
